export interface ForemanEmployeeInOut {
  foremanEmployeeInOutID: string;
  foremanEmployeeLaborID: string;
  foremanEmployeeJobID: string;
  timeIn: Date;
  timeOut: Date;
  bActive: boolean;
  modifiedDate: Date | null;
}
